<template>
  <v-app id="keep">
    <v-app-bar app dark clipped-left color="primary">
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <span class="title ml-3 mr-5"
        >JSON<span class="font-weight-light">ToModel</span></span
      >
      <v-autocomplete
        v-model="converter"
        hide-no-data
        solo-inverted
        flat
        hide-details
        label="Select Conversion Method"
        item-text="title"
        return-object
        :items="converters"
        auto-select-first
      />

      <v-spacer />
      <v-toolbar-items>
        <v-btn
          tile
          text
          large
          :disabled="!copyEnabled"
          @click="copyGeneratedModel(model.join('\n\n'))"
        >
          <v-icon class="mr-2">mdi-content-copy</v-icon>
          Copy
        </v-btn>
        <v-menu
          bottom
          offset-y
          nudge-bottom="10"
          open-on-hover
          transition="scroll-y-reverse-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-at</v-icon>
            </v-btn>
          </template>

          <v-list dense nav>
            <v-list-item
              href="https://www.linkedin.com/in/obella-isaac-3bb759aa/"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>mdi-linkedin</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>LinkeIn</v-list-item-subtitle>
            </v-list-item>

            <v-list-item href="https://twitter.com/wizlif144" target="_blank">
              <v-list-item-icon>
                <v-icon>mdi-twitter</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>Twitter</v-list-item-subtitle>
            </v-list-item>

            <v-list-item
              href="https://stackoverflow.com/users/6056359/isaac-obella"
              target="_blank"
            >
              <v-list-item-icon>
                <v-icon>mdi-stack-exchange</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>Stackoverflow</v-list-item-subtitle>
            </v-list-item>

            <v-list-item href="https://github.com/wizlif" target="_blank">
              <v-list-item-icon>
                <v-icon>mdi-github</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>Github</v-list-item-subtitle>
            </v-list-item>

            <v-list-item href="https://medium.com/@wizlif.144" target="_blank">
              <v-list-item-icon>
                <v-icon>mdi-notebook</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>Medium</v-list-item-subtitle>
            </v-list-item>

            <v-list-item href="https://wizlif.github.io" target="_blank">
              <v-list-item-icon>
                <v-icon>mdi-web</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>Website</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped color="grey lighten-4">
      <v-form ref="form" v-model="form">
        <v-list dense class="grey lighten-4">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Class Name</v-list-item-subtitle>
              <v-text-field
                solo
                v-model="className"
                :rules="[required, camelCase]"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense v-if="isModelBrickhub">
            <v-checkbox v-model="use_json" label="json"></v-checkbox>
          </v-list-item>
          <v-list-item dense v-if="isModelBrickhub">
            <v-checkbox v-model="equatable" label="equatable"></v-checkbox>
          </v-list-item>
          <v-list-item dense v-if="isModelBrickhub">
            <v-checkbox v-model="copy_with" label="copyWith"></v-checkbox>
          </v-list-item>
          <v-list-item dense v-if="isModelBrickhub">
            <v-select
              v-model="style"
              label="style"
              outlined
              :items="['basic', 'json_serializable', 'freezed']"
            />
          </v-list-item>
        </v-list>
      </v-form>
      <ins
        class="adsbygoogle"
        style="display:inline-block;width:336px;height:280px"
        data-ad-client="ca-pub-2894305280846154"
        data-adtest="on"
      ></ins>
    </v-navigation-drawer>

    <v-content>
      <v-form ref="dataForm" v-model="dataForm" lazy-validation>
        <v-container fluid class="grey lighten-4 fill-height">
          <v-row justify="center" align="center">
            <v-col cols="12" md="6" sm="12">
              <v-label>JSON</v-label>
              <v-card height="calc(100vh - 116px)">
                <vue-json-editor
                  v-model="json"
                  solo
                  class="caption"
                  :show-btns="false"
                  mode="code"
                  :expandedOnStart="true"
                />
              </v-card>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-label>Models</v-label>
              <!--                            <v-textarea-->
              <!--                                    v-model="model"-->
              <!--                                    solo-->
              <!--                                    height=""-->
              <!--                                    readonly-->
              <!--                                    class="caption"-->
              <!--                            ></v-textarea>-->
              <div style="overflow-y: scroll;height: calc(100vh - 116px);">
                <v-card
                  v-for="(m, index) in model"
                  :key="index"
                  color="white"
                  elevation="3"
                  class="ma-2"
                >
                  <v-card-text class="pa-0 ma-0">
                    <v-btn
                      icon
                      style="position: relative;float: right;"
                      large
                      @click="copyGeneratedModel(m)"
                      ><v-icon>mdi-content-copy</v-icon></v-btn
                    >
                    <highlightjs :language="converter.language" :code="m" />
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-content>
    <v-snackbar v-model="snackbar" :color="color" bottom left>
      {{ text }}
      <v-btn color="white" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>

    <!-- Update -->
    <v-dialog v-model="updateExists" max-width="290">
      <v-card>
        <v-card-title class="headline">Update Available ?</v-card-title>

        <v-card-text>
          New updates for JSON 2 Model available, click update to have the
          coolest new features and JSON Processors.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="refreshApp">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import mixins from "./mixins/java-processor";
import updates from "./mixins/update";
import { version } from "../package.json";
import vueJsonEditor from "vue-json-editor";
export default {
  mixins: [mixins, updates],
  components: {
    vueJsonEditor
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    snackbar: null,
    text: "",
    color: "",
    json: undefined,
    model: [],
    form: true,
    dataForm: true,
    className: "Example",
    user_id: "",
    required: v => !!v || "Required",
    camelCase: v => /^[a-zA-Z0-9]+$/.test(v) || "Invalid Class Name",
    validJSON: v => {
      try {
        JSON.parse(v);
        return true;
      } catch (e) {
        return "Invalid JSON";
      }
    },
    converters: [
      {
        title: "equatable (Dart)",
        key: "equatable",
        language: "dart"
      },
      {
        title: "model (brickhub.dev)",
        key: "model_brickhub",
        language: "json"
      },
      {
        title: "json_serializable (Dart)",
        key: "json_serializable",
        language: "dart"
      },
      {
        title: "AutoValue-Moshi (Java)",
        key: "autovalue_moshi",
        language: "java"
      },
      {
        title: "Typescript",
        key: "typescript",
        language: "typescript"
      },
      {
        title: "Mashmallow (Python)",
        key: "mashmallow",
        language: "python"
      },
      {
        title: "Moshi (Kotlin)",
        key: "moshi_kotlin",
        language: "kotlin"
      }
    ],
    converter: {
      title: "model (brickhub.dev)",
      key: "model_brickhub",
      language: "dart"
    },
    language: "java",
    to_json: false,
    from_json: false,
    copy_with: false,
    use_json: false,
    equatable: false,
    style: "basic"
  }),
  computed: {
    copyEnabled() {
      return !!this.model;
    },
    isEquatable() {
      return this.converter.key === "equatable";
    },
    isModelBrickhub() {
      return this.converter.key === "model_brickhub";
    }
  },
  methods: {
    process() {
      console.log("process");
      // this.$refs.dataForm.validate();
      this.$refs.form.validate();

      // console.log({ data: this.dataForm, form: this.form });

      if (this.form) {
        try {
          this.model = this.processJSON(
            this.className,
            this.json,
            this.converter.key,
            this.use_json,
            this.equatable,
            this.copy_with,
            this.style
          ).reverse();
          // this.text = "JSON Processed Successfully.";
          // this.color = "green";
          // this.snackbar = true;
          this.$analytics.logEvent("json_processed", {
            converter: this.converter.key,
            user: this.user_id
          });
        } catch (e) {
          // this.text = e;
          // this.color = "red";
          // this.snackbar = true;
          this.model = "";
          this.$analytics.logEvent("exception", {
            exDescription: e.message,
            exFatal: true,
            user: this.user_id
          });
        }
      }
    },
    copyGeneratedModel(text) {
      this.copyText(text);
      this.text = "Model Copied to your clipboard.";
      this.color = "green";
      this.snackbar = true;
      this.$analytics.logEvent("model_copied", {
        user: this.user_id
      });
    },
    isPWA() {
      return window && window.matchMedia("(display-mode: standalone)").matches;
    },
  },
  async beforeMount() {
    this.$auth.onAuthStateChanged(function(user) {
      if (user) {
        this.user_id = user.uid;
      }
    });

    try {
      await this.$auth.signInAnonymously();
    } catch (e) {
      this.$analytics.logEvent("exception", {
        exDescription: e.message,
        exFatal: true,
        exCode: e.code
      });
    }
  },
  mounted() {
    this.$analytics.setCurrentScreen("Main");
    this.$analytics.logEvent("page_view");
    this.$analytics.logEvent("screen_view", {
      app_name: this.isPWA() ? "pwa" : "web",
      screen_name: "Main",
      app_version: version,
      user: this.user_id
    });

    (window.adsbygoogle = window.adsbygoogle || []).push({});
  },
  watch: {
    use_json() {
      this.process();
    },
    style() {
      this.process();
    },
    equatable() {
      this.process();
    },
    copy_with() {
      this.process();
    },
    "converter.key"() {
      this.process();
    },
    json() {
      this.process();
    },
    className() {
      this.process();
    },
    deep: true
  }
};
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}

html {
  overflow-y: auto !important;
}

code {
  background-color: white !important;
}

.jsoneditor-vue {
  height: calc(100vh - 116px);
}
</style>
